var _a;
import { UnitSuffix } from '../../defs';
import { noConvert } from '../../internal/converters';
import { pixel } from '../../internal/converters/pixel';
var viewMinToPixel = function (value, options) {
    return value * Math.min(options.viewWidthPixelValue(), options.viewHeightPixelValue()) * 100;
};
var viewMinToCentimeter = function (value, options) {
    return pixel.cm(viewMinToPixel(value, options));
};
var viewMinToMillimeter = function (value, options) {
    return pixel.mm(viewMinToPixel(value, options));
};
var viewMinToQuarter = function (value, options) {
    return pixel.Q(viewMinToPixel(value, options));
};
var viewMinToInch = function (value, options) {
    return pixel.in(viewMinToPixel(value, options));
};
var viewMinToPica = function (value, options) {
    return pixel.pc(viewMinToPixel(value, options));
};
var viewMinToPoint = function (value, options) {
    return pixel.pt(viewMinToPixel(value, options));
};
var viewMinToREM = function (value, options) {
    return pixel.rem(viewMinToPixel(value, options), options);
};
var viewMinToEM = function (value, options) {
    return pixel.em(viewMinToPixel(value, options), options);
};
var viewMinToViewWidth = function (value, options) {
    return pixel.vw(viewMinToPixel(value, options), options);
};
var viewMinToViewHeight = function (value, options) {
    return pixel.vh(viewMinToPixel(value, options), options);
};
var viewMinToViewMax = function (value, options) {
    return pixel.vmax(viewMinToPixel(value, options), options);
};
export var viewMin = (_a = {},
    _a[UnitSuffix.Pixel] = viewMinToPixel,
    _a[UnitSuffix.Centimeter] = viewMinToCentimeter,
    _a[UnitSuffix.Millimeter] = viewMinToMillimeter,
    _a[UnitSuffix.Quarter] = viewMinToQuarter,
    _a[UnitSuffix.Inch] = viewMinToInch,
    _a[UnitSuffix.Pica] = viewMinToPica,
    _a[UnitSuffix.Point] = viewMinToPoint,
    _a[UnitSuffix.REM] = viewMinToREM,
    _a[UnitSuffix.EM] = viewMinToEM,
    _a[UnitSuffix.ViewWidth] = viewMinToViewWidth,
    _a[UnitSuffix.ViewHeight] = viewMinToViewHeight,
    _a[UnitSuffix.ViewMin] = noConvert,
    _a[UnitSuffix.ViewMax] = viewMinToViewMax,
    _a);
//# sourceMappingURL=view-min.js.map